import React from 'react';
import { Bot } from 'lucide-react';
import { sendIncidentChatMessage } from '@/api/websocket';
import { IncidentDetails } from '@/api/client';
import { BaseChat } from '@/components/chat/BaseChat';
import { YAMLFixesDisplay } from '@/components/chat/YAMLFixesDisplay';
import { ChatMessage } from '@/components/chat/chat-utils';

interface IncidentChatProps {
  incident: IncidentDetails;
}

export function IncidentChat({ incident }: IncidentChatProps) {
  return (
    <BaseChat
      config={{
        sendMessage: (inputText: string) =>
          sendIncidentChatMessage(inputText, incident.id, incident, incident.cluster_name),
        samplePrompts: [
          "What caused this incident?",
          "Show me kubectl commands to investigate further",
          "How can I prevent this from happening again?",
          "What's the impact of this incident?",
        ],
        headerIcon: (
          <div className="relative">
            <Bot className="relative h-6 w-6 text-foreground" />
          </div>
        ),
        headerTitle: "AI Incident Assistant",
        emptyHeading: "Ask me about this incident",
        emptyDescription: "I can help investigate this incident, suggest fixes, and provide kubectl commands to diagnose the issue.",
        inputPlaceholder: "Ask about this incident...",
        colorTheme: 'primary',
        fixType: 'yaml',
        renderFixes: (message: ChatMessage) =>
          message.yamlFixes ? <YAMLFixesDisplay yamlFixes={message.yamlFixes} /> : null,
        renderStreamingFixes: (fixes) =>
          <YAMLFixesDisplay yamlFixes={fixes as any} />,
        fixesLoadingText: "Loading configuration fixes",
        contextType: 'incident',
        contextId: incident.id,
      }}
    />
  );
}
